import { useEffect } from 'react'

/**
 * Пока есть несохранённые правки, браузер переспросит перед уходом со
 * страницы: закрыть вкладку, обновить, перейти по адресу. Переходы внутри
 * приложения правки не теряют — черновик живёт в экране.
 */
export function useUnsavedWarning(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return
    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault()
    }
    window.addEventListener('beforeunload', warn)
    return () => {
      window.removeEventListener('beforeunload', warn)
    }
  }, [dirty])
}
